/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ index: NonNullable<unknown> }} Video_Export_Magnified_Event_HintInputs */



/**
* | output |
* | --- |
* | "Event {index} - Click anywhere outside to close" |
*
* @param {Video_Export_Magnified_Event_HintInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const video_export_magnified_event_hint = /** @type {((inputs: Video_Export_Magnified_Event_HintInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Export_Magnified_Event_HintInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ (`Evenement ${i?.index} - Cliquez en dehors pour fermer`)
	if (locale === "de") return /** @type {LocalizedString} */ (`Ereignis ${i?.index} - Klicken Sie irgendwo außerhalb, um es zu schließen`)
	if (locale === "it") return /** @type {LocalizedString} */ (`Evento ${i?.index} - Clicca in un punto qualsiasi all'esterno per chiudere`)
	if (locale === "ru") return /** @type {LocalizedString} */ (`Событие ${i?.index} - Щелкните в любом месте за пределами окна, чтобы закрыть.`)
	if (locale === "es") return /** @type {LocalizedString} */ (`Evento ${i?.index} - Haga clic en cualquier lugar afuera para cerrar`)
	if (locale === "zh-CN") return /** @type {LocalizedString} */ (`事件 ${i?.index} - 点击外部任意位置关闭`)
	if (locale === "ja") return /** @type {LocalizedString} */ (`イベント ${i?.index} - 外側の任意の場所をクリックすると閉じます`)
	if (locale === "hi") return /** @type {LocalizedString} */ (`इवेंट ${i?.index} - बंद करने के लिए बाहर कहीं भी क्लिक करें`)
	if (locale === "pt-PT") return /** @type {LocalizedString} */ (`Evento ${i?.index} - Clique em qualquer lugar fora para fechar`)
	return /** @type {LocalizedString} */ (`Event ${i?.index} - Click anywhere outside to close`)
});